export default "__VITE_ASSET__pfwVy6nB__"